import React, { useLayoutEffect, useRef, useMemo } from 'react';
import { ExperienceStart } from '@atlassian/jira-experience-tracker/src/ui/experience-start/index.tsx';
import { getWillShowNav3 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav3.tsx';
import { TOP_NAV } from '@atlassian/jira-spa-state-controller/src/common/constants.tsx';
import { useSpaStateActions } from '@atlassian/jira-spa-state-controller/src/common/index.tsx';
import { usePageId } from '@atlassian/jira-spa-state-controller/src/components/use-page-id/index.tsx';
import { useRouter } from '@atlassian/react-resource-router';
import { EXPERIENCE_NAVIGATION_TOP_MAIN } from '../../common/constants.tsx';

/**
 * The start tracker for atlassian navigation, what it records,
 * spa app TOP_BAR start
 *
 * start condition, new route and the route is not a redirect
 */
export const AtlassianNavigationStart = () => {
	const [{ location }] = useRouter();
	const [, { setAppStartWithAppId }] = useSpaStateActions();
	const pageId = usePageId();

	const startRef = useRef({
		location,
		startTime: Date.now(),
	});

	useMemo(() => {
		if (location !== startRef.current.location) {
			startRef.current = {
				location,
				startTime: Date.now(),
			};
		}
	}, [location]);

	useLayoutEffect(() => {
		setAppStartWithAppId(TOP_NAV, startRef.current.startTime);
	}, [location, setAppStartWithAppId]);

	return (
		getWillShowNav3() && (
			<ExperienceStart
				experience={EXPERIENCE_NAVIGATION_TOP_MAIN}
				analyticsSource="atlassian-navigation"
				experienceId={pageId}
			/>
		)
	);
};
